import React, { Component } from 'react';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { personalInformation } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import {
  FORM_KEYS,
  // CLIENT_CLASSIFICATION,
  // TYPE_OF_INVESTMENT,
  // QUALIFIED_TYPE_OF_INVESTMENT,
} from 'shared/constant';
import arrOptions from 'shared/constant/arrOptions';
import {
  PaddedContainer, SelectBox,
  FormElementContainer,
  Heading, Label, Notes,
  Input,
  Options,
  // Textarea,
  Modal,
  // ButtonPlus
} from 'components';
import validation from 'shared/validations';

class ClientProfileForm extends Component {
  state = {
    isModalOpen: false,
    modalTitle: '',
    modalContent: null,
  }

  onElementChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    if (fieldName === 'withInvestmentExp' && fieldValue === 'no') {
      /** @todo populate answers to all "No experience" */
      this.props.onAutoUpdateInvestmentExpToNo();
    }

    this.props.onUpdateClientProfile(fieldName, fieldValue);
  }

  onHandleSelect = (name, value) => {
    if (name && value) this.props.onUpdateClientProfile(name, value);
  }

  onHandleMultiSelect = ({ target: { name, id } }) => {
    const oldData = this.props[name] || '';
    let arrOldData = oldData.split(',');
    if (arrOldData.includes(id)) arrOldData = arrOldData.filter(item => item !== id);
    else arrOldData.push(id);
    arrOldData = arrOldData.filter(item => !!item);
    this.props.onUpdateClientProfile(name, arrOldData.toString());
  }

  onInsiderChange = (index, { target }) => {
    this.props.onUpdateInsider(index, target.name, target.value);
  }

  handleRemoveInsider = (id) => {
    this.props.onRemoveInsider(id);
  }

  onHandleUpdateMarkets = ({ target }) => {
    const { id } = target;
    this.props.onUpdateMarkets(id);
  }

  onHandleUpdateAssetClasses = ({ target }) => {
    const { id } = target;
    this.props.onUpdateAssetClasses(id);
  }

  onHandleInfoClick = (e) => {
    this.setState({
      isModalOpen: true,
      modalTitle: this.getModalTitle(e),
      modalContent: this.getModalContent(e),
    });
  }

  getModalTitle = (id) => {
    switch (id) {
      case 'investmentObjectiveTimeHorizon':
        return 'info.investmentObjectiveTimeHorizon.title';
      case 'investmentPreference':
        return 'info.investmentPreference.title';
      default:
        return 'infoBox';
    }
  }

  getModalContent = (id) => {
    switch (id) {
      case 'investmentObjectiveTimeHorizon':
        return (
          <>
            <p><FormattedHTMLMessage id="info.investmentObjectiveTimeHorizon.desc" /></p>
            <table className="default-table" cellPadding="3" cellSpacing="0">
              <tr>
                <th>Objective</th>
                <th>Time horizon</th>
                <th>Liquidity/ Growth</th>
              </tr>
              <tr>
                <th>Income</th>
                <td>3 months</td>
                <td>100% : 0</td>
              </tr>
              <tr>
                <th>Income & Growth</th>
                <td>6 months - 1 year</td>
                <td>75% : 25%</td>
              </tr>
              <tr>
                <th>Growth & Income</th>
                <td>1 year</td>
                <td>50% : 50%</td>
              </tr>
              <tr>
                <th>Growth</th>
                <td>2 - 3 years</td>
                <td>25% : 75%</td>
              </tr>
              <tr>
                <th>Aggressive Growth</th>
                <td>Long term</td>
                <td>0 : 100%</td>
              </tr>
            </table>
          </>
        );
      case 'investmentPreference':
        return (
          <p>
            <FormattedHTMLMessage id="info.investmentPreference.desc" />
          </p>
        );
      default:
        return 'infoBox';
    }
  }

  render() {
    const {
      intl, riskTolerance, investmentPreference, bondsYrs, bondsStrategy, equitiesYrs, equitiesStrategy,
      // goal, derivativesYrs, derivativesStrategy,
      investmentPurpose, otherInvestmentPurpose,
      privateEquityYrs, privateEquityStrategy, realEstateYrs, realEstateStrategy, otherAlternativeYrs, otherAlternativeStrategy,
      independentProfAdvice,
      // objectiveTimeHorizon, assetClass, markets, investmentKnowledge, restrictions, otherRestriction,
      // clientClassification, typeOfInvestment,
      // insiderStatus, onAddMoreInsider, insiderList,
      formOptions: {
        // investmentGoals,
        investmentPurposes,
        riskTolerancesNew,
        investmentPreference: investmentPreferences,
        // investmentPreferences,
        // assetClasses, investmentKnowledges, marketOptions, restrictionOptions, investmentObjectiveTimeHorizons,
        investmentExpY, investmentExpStrategies,
      },
      isSubmitClicked, withInvestmentExp,
    } = this.props;
    const { CLIENT_PROFILE_FORM } = FORM_KEYS;
    const {
      defaultBoolOptions,
      // markets, investmentMaturityTargets, restrictions,
    } = arrOptions;
    const { modalTitle, modalContent } = this.state;

    const {
      // GOAL,
      // WITH_INVESTMENT_EXP,
      INVESTMENT_PURPOSE,
      RISK_TOLERANCE,
      INVESTMENT_PREFERENCE,
      INDEPENDENT_PROF_ADVICE,
      // INVESTMENT_OBJECTIVE_TIME_HORIZON,
      // ASSET_CLASSES,
      // MARKETS,
      // INVESTMENT_KNOWLEDGE,
      // RESTRICTIONS,
      // OTHER_RESTRICTION,

      // Investment Experience
      INVESTMENT_EXP_BONDS_YRS,
      INVESTMENT_EXP_EQUITIES_YRS,
      INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS,
      INVESTMENT_EXP_REAL_ESTATE_YRS,
      INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS,

      // INSIDER_STATUS_LIST_COMPANY,
      // INSIDER_STATUS_LIST_POSITION,
    } = CLIENT_PROFILE_FORM;

    // const isDiscretionary = !!(clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY);

    const elementValidation = {
      // [GOAL]: {
      //   isValid: validation.clientProfileFormSchema(intl, GOAL).isValidSync({ goal }),
      //   errorMessage: validation.getErrorMessages({ goal }, validation.clientProfileFormSchema(intl, GOAL)),
      // },
      [INVESTMENT_PURPOSE]: {
        isValid: validation.clientProfileFormSchema(intl, INVESTMENT_PURPOSE).isValidSync({ investmentPurpose }),
        errorMessage: validation.getErrorMessages({ investmentPurpose }, validation.clientProfileFormSchema(intl, INVESTMENT_PURPOSE)),
      },
      [RISK_TOLERANCE]: {
        isValid: validation.clientProfileFormSchema(intl, RISK_TOLERANCE).isValidSync({ riskTolerance }),
        errorMessage: validation.getErrorMessages({ riskTolerance }, validation.clientProfileFormSchema(intl, RISK_TOLERANCE)),
      },
      [INVESTMENT_PREFERENCE]: {
        isValid: validation.clientProfileFormSchema(intl, INVESTMENT_PREFERENCE).isValidSync({ investmentPreference }),
        errorMessage: validation.getErrorMessages({ investmentPreference }, validation.clientProfileFormSchema(intl, INVESTMENT_PREFERENCE)),
      },
      [INVESTMENT_EXP_BONDS_YRS]: {
        isValid: validation.clientProfileFormSchema(intl, INVESTMENT_EXP_BONDS_YRS).isValidSync({ ieBondsYrs: bondsYrs }),
        errorMessage: validation.getErrorMessages({ ieBondsYrs: bondsYrs }, validation.clientProfileFormSchema(intl, INVESTMENT_EXP_BONDS_YRS)),
      },
      [INVESTMENT_EXP_EQUITIES_YRS]: {
        isValid: validation.clientProfileFormSchema(intl, INVESTMENT_EXP_EQUITIES_YRS).isValidSync({ ieEquitiesYrs: equitiesYrs }),
        errorMessage: validation.getErrorMessages({ ieEquitiesYrs: equitiesYrs }, validation.clientProfileFormSchema(intl, INVESTMENT_EXP_EQUITIES_YRS)),
      },
      [INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS]: {
        isValid: validation.clientProfileFormSchema(intl, INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS).isValidSync({ iePrivateEquityHedgeFundsYrs: privateEquityYrs }),
        errorMessage: validation.getErrorMessages({ iePrivateEquityHedgeFundsYrs: privateEquityYrs }, validation.clientProfileFormSchema(intl, INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS)),
      },
      [INVESTMENT_EXP_REAL_ESTATE_YRS]: {
        isValid: validation.clientProfileFormSchema(intl, INVESTMENT_EXP_REAL_ESTATE_YRS).isValidSync({ ieRealEstateYrs: realEstateYrs }),
        errorMessage: validation.getErrorMessages({ ieRealEstateYrs: realEstateYrs }, validation.clientProfileFormSchema(intl, INVESTMENT_EXP_REAL_ESTATE_YRS)),
      },
      [INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS]: {
        isValid: validation.clientProfileFormSchema(intl, INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS).isValidSync({ ieOtherAlternativeInvestmentsYrs: otherAlternativeYrs }),
        errorMessage: validation.getErrorMessages({ ieOtherAlternativeInvestmentsYrs: otherAlternativeYrs }, validation.clientProfileFormSchema(intl, INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS)),
      },
      [INDEPENDENT_PROF_ADVICE]: {
        isValid: validation.clientProfileFormSchema(intl, INDEPENDENT_PROF_ADVICE).isValidSync({ independentProfAdvice }),
        errorMessage: validation.getErrorMessages({ independentProfAdvice }, validation.clientProfileFormSchema(intl, INDEPENDENT_PROF_ADVICE)),
      },
      // [INVESTMENT_OBJECTIVE_TIME_HORIZON]: {
      //   isValid: validation.clientProfileFormSchema(intl, INVESTMENT_OBJECTIVE_TIME_HORIZON, isDiscretionary).isValidSync({ investmentObjectiveTimeHorizon: objectiveTimeHorizon }),
      //   errorMessage: validation.getErrorMessages({ investmentObjectiveTimeHorizon: objectiveTimeHorizon }, validation.clientProfileFormSchema(intl, INVESTMENT_OBJECTIVE_TIME_HORIZON, isDiscretionary)),
      // },
      // [ASSET_CLASSES]: {
      //   isValid: validation.clientProfileFormSchema(intl, ASSET_CLASSES, isDiscretionary).isValidSync({ assetClasses: assetClass }),
      //   errorMessage: validation.getErrorMessages({ assetClasses: assetClass }, validation.clientProfileFormSchema(intl, ASSET_CLASSES, isDiscretionary)),
      // },
      // [MARKETS]: {
      //   isValid: validation.clientProfileFormSchema(intl, MARKETS, isDiscretionary).isValidSync({ markets }),
      //   errorMessage: validation.getErrorMessages({ markets }, validation.clientProfileFormSchema(intl, MARKETS, isDiscretionary)),
      // },
      // [INVESTMENT_KNOWLEDGE]: {
      //   isValid: validation.clientProfileFormSchema(intl, INVESTMENT_KNOWLEDGE, isDiscretionary).isValidSync({ investmentKnowledge }),
      //   errorMessage: validation.getErrorMessages({ investmentKnowledge }, validation.clientProfileFormSchema(intl, INVESTMENT_KNOWLEDGE, isDiscretionary)),
      // },
      // [RESTRICTIONS]: {
      //   isValid: validation.clientProfileFormSchema(intl, RESTRICTIONS, isDiscretionary).isValidSync({ restrictions }),
      //   errorMessage: validation.getErrorMessages({ restrictions }, validation.clientProfileFormSchema(intl, RESTRICTIONS, isDiscretionary)),
      // },
      // [OTHER_RESTRICTION]: {
      //   isValid: validation.clientProfileFormSchema(intl, OTHER_RESTRICTION, isDiscretionary, restrictions).isValidSync({ otherRestriction }),
      //   errorMessage: validation.getErrorMessages({ otherRestriction }, validation.clientProfileFormSchema(intl, OTHER_RESTRICTION, isDiscretionary)),
      // },
    };

    // const isInsiderListValid = validation.insiderListSchema(intl, insiderStatus).isValidSync({ insiderStatusList: insiderList });

    return (
      <>
        <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
          <FormElementContainer>
            {/* <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'clientProfileForm.goal' })} />
              <Options
                type="checkbox"
                hasContainer
                name={CLIENT_PROFILE_FORM.GOAL}
                optionList={investmentGoals}
                onCheckMarkChange={this.onHandleMultiSelect}
                defaultValue={goal}
                isValid={elementValidation[GOAL].isValid}
                errorMessage={elementValidation[GOAL].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer> */}

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'clientProfileForm.investmentPurpose' })} />
              <Options
                type="checkbox"
                hasContainer
                name={CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE}
                optionList={investmentPurposes}
                onCheckMarkChange={this.onHandleMultiSelect}
                defaultValue={investmentPurpose}
                isValid={elementValidation[INVESTMENT_PURPOSE].isValid}
                errorMessage={elementValidation[INVESTMENT_PURPOSE].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>
            {investmentPurpose?.includes('NW-MAR-INP-OTH') && (
              <Input
                name={CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE_OTHERS}
                label={intl.formatMessage({ id: 'clientProfileForm.investmentPurposeOthers' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientProfileForm.investmentPurposeOthers' }).toLowerCase()}`}
                onInputChange={this.onElementChange}
                value={otherInvestmentPurpose}
              />
            )}
            <FormElementContainer>
              <SelectBox
                name={CLIENT_PROFILE_FORM.RISK_TOLERANCE}
                label={intl.formatMessage({ id: 'clientProfileForm.riskTolerance' })}
                placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientProfileForm.riskTolerance' }).toLowerCase()}`}
                dataList={riskTolerancesNew}
                onSelect={this.onHandleSelect}
                defaultValue={riskTolerance}
                isValid={elementValidation[RISK_TOLERANCE].isValid}
                errorMessage={elementValidation[RISK_TOLERANCE].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>
          </FormElementContainer>
          <FormElementContainer>
            <Label
              label={intl.formatMessage({ id: 'clientProfileForm.investmentPreference' })}
              id="investmentPreference"
              withInfo
              onWithInfoClick={e => this.onHandleInfoClick(e)}
            />
            <FormElementContainer>
              <SelectBox
                name={CLIENT_PROFILE_FORM.INVESTMENT_PREFERENCE}
                placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientProfileForm.investmentPreference' }).toLowerCase()}`}
                dataList={investmentPreferences}
                onSelect={this.onHandleSelect}
                defaultValue={investmentPreference}
                isValid={elementValidation[INVESTMENT_PREFERENCE].isValid}
                errorMessage={elementValidation[INVESTMENT_PREFERENCE].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>
          </FormElementContainer>
        </PaddedContainer>

        {/* INVESTMENT EXPERIENCE */}
        <FormElementContainer isLightBg>
          <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
            <Heading title={intl.formatMessage({ id: 'clientProfileForm.investmentExp' })} />

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'clientProfileForm.withInvestmentExp' })} />
              <Options
                  isMultpleElements
                  type="radio"
                  hasContainer
                  name={CLIENT_PROFILE_FORM.WITH_INVESTMENT_EXP}
                  optionList={defaultBoolOptions}
                  onCheckMarkChange={this.onElementChange}
                  defaultValue={withInvestmentExp}
                  // isValid={elementValidation[WITH_INVESTMENT_EXP].isValid}
                  // errorMessage={elementValidation[WITH_INVESTMENT_EXP].errorMessage}
                  // isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            <hr />

            {withInvestmentExp === '' ? null : (
                <React.Fragment>
                  <FormElementContainer>
                    <Label label={intl.formatMessage({ id: 'clientProfileForm.bonds' })} />
                    <FormElementContainer isMultpleElements>
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_YRS}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'years' })}`}
                          dataList={investmentExpY}
                          onSelect={this.onHandleSelect}
                          defaultValue={bondsYrs}
                          isValid={elementValidation[INVESTMENT_EXP_BONDS_YRS].isValid}
                          errorMessage={elementValidation[INVESTMENT_EXP_BONDS_YRS].errorMessage}
                          isSubmitClicked={isSubmitClicked}
                      />

                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_STRATEGY}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'strategy' })}`}
                          dataList={investmentExpStrategies}
                          onSelect={this.onHandleSelect}
                          defaultValue={bondsStrategy}
                      />
                    </FormElementContainer>
                  </FormElementContainer>

                  <FormElementContainer>
                    <Label label={intl.formatMessage({ id: 'clientProfileForm.equities' })} />
                    <FormElementContainer isMultpleElements>
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_YRS}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'years' })}`}
                          dataList={investmentExpY}
                          onSelect={this.onHandleSelect}
                          defaultValue={equitiesYrs}
                          isValid={elementValidation[INVESTMENT_EXP_EQUITIES_YRS].isValid}
                          errorMessage={elementValidation[INVESTMENT_EXP_EQUITIES_YRS].errorMessage}
                          isSubmitClicked={isSubmitClicked}
                      />
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_STRATEGY}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'strategy' })}`}
                          dataList={investmentExpStrategies}
                          onSelect={this.onHandleSelect}
                          defaultValue={equitiesStrategy}
                      />
                    </FormElementContainer>
                  </FormElementContainer>

                  <FormElementContainer>
                    <Label label={intl.formatMessage({ id: 'clientProfileForm.privateEquityHedgeFunds' })} />
                    <FormElementContainer isMultpleElements>
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'years' })}`}
                          dataList={investmentExpY}
                          onSelect={this.onHandleSelect}
                          defaultValue={privateEquityYrs}
                          isValid={elementValidation[INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS].isValid}
                          errorMessage={elementValidation[INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS].errorMessage}
                          isSubmitClicked={isSubmitClicked}
                      />
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_STRATEGY}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'strategy' })}`}
                          dataList={investmentExpStrategies}
                          onSelect={this.onHandleSelect}
                          defaultValue={privateEquityStrategy}
                      />
                    </FormElementContainer>
                  </FormElementContainer>

                  <FormElementContainer>
                    <Label label={intl.formatMessage({ id: 'clientProfileForm.realEstate' })} />
                    <FormElementContainer isMultpleElements>
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_YRS}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'years' })}`}
                          dataList={investmentExpY}
                          onSelect={this.onHandleSelect}
                          defaultValue={realEstateYrs}
                          isValid={elementValidation[INVESTMENT_EXP_REAL_ESTATE_YRS].isValid}
                          errorMessage={elementValidation[INVESTMENT_EXP_REAL_ESTATE_YRS].errorMessage}
                          isSubmitClicked={isSubmitClicked}
                      />
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_STRATEGY}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'strategy' })}`}
                          dataList={investmentExpStrategies}
                          onSelect={this.onHandleSelect}
                          defaultValue={realEstateStrategy}
                      />
                    </FormElementContainer>
                  </FormElementContainer>

                  <FormElementContainer>
                    <Label label={intl.formatMessage({ id: 'clientProfileForm.otherAlternative' })} />
                    <FormElementContainer isMultpleElements>
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'years' })}`}
                          dataList={investmentExpY}
                          onSelect={this.onHandleSelect}
                          defaultValue={otherAlternativeYrs}
                          isValid={elementValidation[INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS].isValid}
                          errorMessage={elementValidation[INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS].errorMessage}
                          isSubmitClicked={isSubmitClicked}
                      />
                      <SelectBox
                          name={CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_STRATEGY}
                          placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'strategy' })}`}
                          dataList={investmentExpStrategies}
                          onSelect={this.onHandleSelect}
                          defaultValue={otherAlternativeStrategy}
                      />
                    </FormElementContainer>
                  </FormElementContainer>
                </React.Fragment>
            )}


            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'clientProfileForm.accessToIndependent' })} />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                name={CLIENT_PROFILE_FORM.INDEPENDENT_PROF_ADVICE}
                optionList={defaultBoolOptions.map(item => ({ id: `isIpa-${item.id}`, label: item.label }))}
                onCheckMarkChange={this.onElementChange}
                defaultValue={independentProfAdvice}
                isValid={elementValidation[INDEPENDENT_PROF_ADVICE].isValid}
                errorMessage={elementValidation[INDEPENDENT_PROF_ADVICE].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            <Notes
              msg={(
                <div>
                  <FormattedHTMLMessage id="info.needsAnswer" />
                </div>
                )}
            />

          </PaddedContainer>
        </FormElementContainer>

        <hr />

        {/* DISPLAY BELOW IF USER IS NOT CLASSIFIED AS RETAIL CLIENT */}
        {/* {clientClassification !== CLIENT_CLASSIFICATION.RETAIL && (
          <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
            <FormElementContainer>
              <SelectBox
                withInfo
                name={CLIENT_PROFILE_FORM.INVESTMENT_OBJECTIVE_TIME_HORIZON}
                label={intl.formatMessage({ id: 'clientProfileForm.investmentObj' })}
                onWithInfoClick={e => this.onHandleInfoClick(e)}
                placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientProfileForm.investmentObj.placeholder' })}`}
              // dataList={investmentObjectiveTimeHorizons.map(item => item.objective)}
                dataList={investmentObjectiveTimeHorizons.map(item => ({ id: item.id, label: `${item.label}.front` }))}
                onSelect={this.onHandleSelect}
                defaultValue={objectiveTimeHorizon}
                isValid={elementValidation[INVESTMENT_OBJECTIVE_TIME_HORIZON].isValid}
                errorMessage={elementValidation[INVESTMENT_OBJECTIVE_TIME_HORIZON].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />

              <Heading title={intl.formatMessage({ id: 'clientProfileForm.investmentGuidelines' })} />

              <FormElementContainer>
                <Label label={intl.formatMessage({ id: 'clientProfileForm.assetClasses' })} />
                <Options
                  type="checkbox"
                  hasContainer
                  name={CLIENT_PROFILE_FORM.ASSET_CLASSES}
                  optionList={assetClasses}
                  onCheckMarkChange={this.onHandleUpdateAssetClasses}
                  defaultValue={assetClass}
                  isValid={elementValidation[ASSET_CLASSES].isValid}
                  errorMessage={elementValidation[ASSET_CLASSES].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
            </FormElementContainer>

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'clientProfileForm.markets' })} />
              <Options
                type="checkbox"
                hasContainer
                name={CLIENT_PROFILE_FORM.MARKETS}
                optionList={marketOptions}
                onCheckMarkChange={this.onHandleUpdateMarkets}
                defaultValue={markets}
                isValid={elementValidation[MARKETS].isValid}
                errorMessage={elementValidation[MARKETS].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            <FormElementContainer>
              <SelectBox
                name={CLIENT_PROFILE_FORM.INVESTMENT_KNOWLEDGE}
                label={intl.formatMessage({ id: 'clientProfileForm.investmentKnowledge' })}
                placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientProfileForm.investmentKnowledge' })}`}
                dataList={investmentKnowledges}
                onSelect={this.onHandleSelect}
                defaultValue={investmentKnowledge}
                isValid={elementValidation[INVESTMENT_KNOWLEDGE].isValid}
                errorMessage={elementValidation[INVESTMENT_KNOWLEDGE].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'clientProfileForm.restrictions' })} />
              <Options
                type="radio"
                hasContainer
                name={CLIENT_PROFILE_FORM.RESTRICTIONS}
                optionList={restrictionOptions}
                onCheckMarkChange={this.onElementChange}
                defaultValue={restrictions}
                isValid={elementValidation[RESTRICTIONS].isValid}
                errorMessage={elementValidation[RESTRICTIONS].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            {(restrictions === 'NW-MAR-RES-THREE' || restrictions === 'NW-MAR-RES-FOUR' || restrictions === 'NW-MAR-RES-FIVE') && (
            <FormElementContainer isLightBg isWithPadding>
              <Textarea
                name={CLIENT_PROFILE_FORM.OTHER_RESTRICTION}
                label={intl.formatMessage({ id: 'restriction.pleaseSpecify' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'restriction.pleaseSpecify' }).toLowerCase()}`}
                onInputChange={this.onElementChange}
                value={otherRestriction}
                isValid={elementValidation[OTHER_RESTRICTION].isValid}
                errorMessage={elementValidation[OTHER_RESTRICTION].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>
            )}
          </PaddedContainer>
        )} */}

        <Modal withPadding showModal={this.state.isModalOpen} title={modalTitle ? intl.formatMessage({ id: modalTitle }) : ''} onClose={() => this.setState({ isModalOpen: false })}>
          {/* <span>Content here</span> */}
          {modalContent}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: selectors.getLanguage(state),
  clientClassification: selectors.getClientClassification(state),
  typeOfInvestment: selectors.getTypeOfInvestment(state),
  formOptions: selectors.getFormOptions(state),
  goal: selectors.getCpfGoal(state),
  investmentPurpose: selectors.getCpfInvestmentPurpose(state),
  otherInvestmentPurpose: selectors.getCpfInvestmentPurposeOthers(state),
  riskTolerance: selectors.getCpfRiskTolerance(state),
  investmentPreference: selectors.getCpfInvestmentPreference(state),
  bondsYrs: selectors.getCpfBondsYrs(state),
  bondsStrategy: selectors.getCpfBondsStrategy(state),
  equitiesYrs: selectors.getCpfEquitiesYrs(state),
  equitiesStrategy: selectors.getCpfEquitiesStrategy(state),
  // derivativesYrs: selectors.getCpfDerivativesYrs(state),
  // derivativesStrategy: selectors.getCpfDerivativesStrategy(state),
  privateEquityYrs: selectors.getCpfPrivateEquityYrs(state),
  privateEquityStrategy: selectors.getCpfPrivateEquityStrategy(state),
  realEstateYrs: selectors.getCpfRealEstateYrs(state),
  realEstateStrategy: selectors.getCpfRealEstateStrategy(state),
  otherAlternativeYrs: selectors.getCpfOtherAlternativeYrs(state),
  otherAlternativeStrategy: selectors.getCpfOtherAlternativeStrategy(state),
  independentProfAdvice: selectors.getCpfIndependentProfAdvice(state),
  insiderStatus: selectors.getCpfInsiderStatus(state),
  // objectiveTimeHorizon: selectors.getCpfObjectiveTimeHorizon(state),
  // assetClass: selectors.getCpfAssetClasses(state),
  // markets: selectors.getCpfMarkets(state),
  // investmentKnowledge: selectors.getCpfInvestmentKnowledge(state),
  // restrictions: selectors.getCpfRestrictions(state),
  // otherRestriction: selectors.getCpfOtherRestriction(state),
  // otherSector: selectors.getCpfOtherSector(state),
  // otherIssuer: selectors.getCpfOtherIssuer(state),
  insiderList: selectors.getInsiderList(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),
  withInvestmentExp: selectors.getWithInvestmentExp(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateClientProfile: (name, value) => dispatch(personalInformation.updateClientProfile(name, value)),
  onAddMoreInsider: () => dispatch(personalInformation.addMoreInsider()),
  onUpdateInsider: (index, key, value) => dispatch(personalInformation.updateInsiderList(index, key, value)),
  onRemoveInsider: id => dispatch(personalInformation.removeInsiderItem(id)),
  onUpdateAssetClasses: selectedId => dispatch(personalInformation.updateAssetClasses(selectedId)),
  onUpdateMarkets: selectedId => dispatch(personalInformation.updateMarkets(selectedId)),
  onAutoUpdateInvestmentExpToNo: () => dispatch(personalInformation.autoUpdateInvestmentExpToNo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ClientProfileForm));
